import { ChakraProvider } from '@chakra-ui/react'
import chakraTheme from 'shared/style/chakra'

const withChakra = component => () =>
  <ChakraProvider theme={chakraTheme}>{component()}</ChakraProvider>

export default withChakra
